export default __webpack_public_path__ + "static/media/Calculus.17187f57.jpg";